"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "tab_selector-module__container___pTNPc",
  "tab": "tab_selector-module__tab___KamjT",
  "selected": "tab_selector-module__selected___dCJAr tab_selector-module__tab___KamjT",
  "unselected": "tab_selector-module__unselected___yc0Ai tab_selector-module__tab___KamjT"
};
class TabSelector extends _AuComponent.default {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIdx: this.props.defaultTabIdx
    };
  }
  tabClick(idx) {
    this.setState({
      activeTabIdx: idx
    });
    const tab = this.props.tabs[idx];
    if (tab.onClick) {
      tab.onClick(tab);
    }
  }
  render() {
    const tabs = this.props.tabs;
    const tabSpans = [];
    (0, _forEach.default)(tabs).call(tabs, (tab, idx) => {
      const className = this.state.activeTabIdx === idx ? styles.selected : styles.unselected;
      tabSpans.push( /*#__PURE__*/_react.default.createElement(_AutoIntl.default, (0, _extends2.default)({}, tabs[idx], {
        key: idx,
        className: className,
        onClick: () => this.tabClick(idx)
      })));
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.container
    }, tabSpans);
  }
  static propTypes = {
    tabs: T.arrayOf(T.shape({
      displayId: T.string,
      displayString: T.string,
      onClick: T.func
    })),
    defaultTabIdx: T.number
  };
  static defaultProps = {
    defaultTabIdx: 0
  };
}
exports.default = TabSelector;